import { createApp } from "vue";
import { createPinia, setActivePinia } from "pinia";
import naive from "naive-ui";

import { villusClient } from "./villusClient";
import SearchBarWrapper from "./components/SearchBarWrapper.vue";

const app = createApp(SearchBarWrapper);

const pinia = createPinia();
app.use(pinia);
setActivePinia(pinia);

app.use(naive);
app.use(villusClient);

app.mount("#booking-searchbar");
